const Seemple = require('./seemple').default;
const SeempleArray = require('./array').default;
const SeempleObject = require('./object').default;

Seemple.Object = SeempleObject;
Seemple.Array = SeempleArray;

module.exports = Seemple;
